/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Box } from '@mui/material';
import Image from '@app/components/atoms/Image'

const MediaGrid = ({ mediaUrls, setExpandedMedia }) => (
  mediaUrls?.length > 0 && (
    <Grid container xs={12} sx={{ margin: '5px', borderRadius: '10px', overflow: 'hidden' }}>
      <Grid item xs={mediaUrls?.length === 1 ? 12 : 6} sx={{ height: '350px', backgroundColor: 'rgba(0, 0, 0, 0.1)' }}>
        {mediaUrls?.map((url, idx) => (
          idx === 0 && (
            <Image
              key={idx}
              src={url}
              alt={url}
              height="100%"
              fitCover="cover"
              onClick={() => setExpandedMedia({ urls: mediaUrls, index: idx })}
            />
          )
        ))}
      </Grid>
      {mediaUrls?.length > 1 &&
        <Grid item xs={6} sx={{ height: '350px' }}>
          {mediaUrls?.map((url, idx) => (
            idx > 0 && (
              <Grid item key={idx} md={12} sx={{ height: mediaUrls?.length === 2 ? '350px' : '175px', bgcolor: 'rgba(0, 0, 0, 0.1)' }}>
                {idx === 1 && (
                  <Image
                    src={url}
                    alt={url}
                    height="100%"
                    fitCover="cover"
                    onClick={() => setExpandedMedia({ urls: mediaUrls, index: idx })}
                  />
                )}
                {idx === 2 && (
                  <>
                    {mediaUrls?.length > 3 ? (
                      <Box
                        sx={{
                          height: '175px',
                          cursor: 'pointer',
                          backgroundImage: `url(${mediaUrls[2]})`,
                          backgroundSize: 'cover',
                          backgroundPosition: 'center'
                        }}
                        onClick={() => setExpandedMedia({ urls: mediaUrls, index: idx })}
                      >
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: '100%',
                          height: '100%',
                          backgroundColor: 'rgba(0, 0, 0, 0.5)',
                          color: 'white',
                          fontSize: '3rem',
                          fontWeight: 'medium'
                        }}>
                          +{mediaUrls.length - 3}
                        </div>
                      </Box>
                    ) : (
                      <Image
                        src={url}
                        alt={url}
                        height="100%"
                        fitCover="cover"
                        onClick={() => setExpandedMedia({ urls: mediaUrls, index: idx })}
                        style={{backgroundColor: 'rgba(0, 0, 0, 0.1)'}}
                      />
                    )}
                  </>
                )}
              </Grid>
            )
          ))}
        </Grid>
      }
    </Grid>
  )
);

MediaGrid.propTypes = {
  mediaUrls: PropTypes.array.isRequired,
  setExpandedMedia: PropTypes.func.isRequired,
};


export default MediaGrid;
